export const emailRegex = /^[a-z0-9.\-_+!#$%&'*/=?^`{}~|]+@([a-z0-9-]+\.)+[a-z]{2,4}$/i;

export const stringRegex = /[A-Za-z0-9\- .]+/;
